export default async function cartButton({main, state, elm, subscribe}) {
	const miniCart = document.querySelector('cart-mini');
	let longPressTimer = null;
	let suppressNextClick = false;
	let longPressTriggered = false;

	main(_ => {
		elm.addEventListener('click', displayMiniCart);
		elm.addEventListener('pointerdown', handlePointerDown);
		elm.addEventListener('pointerup', clearLongPressTimer);
		elm.addEventListener('pointercancel', clearLongPressTimer);
		elm.addEventListener('contextmenu', handleContextMenu);
		document.addEventListener('pointerdown', clearLongPressStateOnOutsidePress, true);
		subscribe('cart-counter', updateCounter);
	});

	const displayMiniCart = async function (event) {
		if (suppressNextClick) {
			event.preventDefault();
			event.stopPropagation();
			suppressNextClick = false;
			return;
		}

		await miniCart.update();
		miniCart.display();
	};

	const handlePointerDown = function (event) {
		if (event.pointerType !== 'touch') {
			return;
		}

		resetLongPressState();

		longPressTimer = window.setTimeout(() => {
			longPressTriggered = true;
			suppressNextClick = true;
			elm.classList.add('cart-button--long-press');
		}, 450);
	};

	const clearLongPressTimer = function () {
		if (longPressTimer) {
			window.clearTimeout(longPressTimer);
			longPressTimer = null;
		}
	};

	const clearLongPressStateOnOutsidePress = function (event) {
		if (!elm.classList.contains('cart-button--long-press')) {
			return;
		}

		if (elm.contains(event.target)) {
			return;
		}

		resetLongPressState();
	};

	const handleContextMenu = function (event) {
		if (!longPressTriggered) {
			return;
		}

		event.preventDefault();
	};

	const resetLongPressState = function () {
		clearLongPressTimer();
		longPressTriggered = false;
		suppressNextClick = false;
		elm.classList.remove('cart-button--long-press');
	};

	const updateCounter = function (counter) {
		state.set(s => s.quantity = counter);
	};
};

export const model = {};

export const view = ( state ) => {
	const quantityStyle = state.quantity ? `--cart-quantity: '${state.quantity}'` : null;

	return {
		...state,
		quantityStyle,
	}
}
